module.exports = __webpack_public_path__ + "static/img/banner.fa4b9162.png";